import { writable } from 'svelte/store';

export const currentRoute = writable(window.location.pathname);